// @ core
const apiURLBuilder = require("core/apiURLBuilder");
// @ utilities
const { APIGet } = require("utilities/APIRequestHelper");
const { notifyError } = require("utilities/adrumHelper")
// @ vendor
const moment = require('moment');
// @ constants
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');

const getDates = (filterSelected, originCountry) => {
    const dateFormat = DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_TIMESERIES
    const toDate = moment(Date.now()).format(dateFormat)
    const fromDate = new Date()
    switch (filterSelected) {
        case 1: // 1 week
            fromDate.setDate(fromDate.getDate() - 7)
            break;

        case 2: // 1 month
            fromDate.setMonth(fromDate.getMonth() - 1)
            break;

        case 3: // 1 year
            fromDate.setFullYear(fromDate.getFullYear() - 1)
            break;

        case 4: // 3 years
            fromDate.setFullYear(fromDate.getFullYear() - 3)
        break;

        default:
            fromDate.setFullYear(fromDate.getFullYear() - 3)
            break;
    }

    return {
        toDate,
        fromDate: moment(fromDate).format(dateFormat)
    }
}

const prepareIntradayResponse = data => {
    let dataChartNewArrForOneday = []
    let hoursArray = []
    let dateValue , getHours
    data.map((dataChartPoints) => {
        dateValue = new Date(dataChartPoints.openDate)
        getHours = dateValue.getHours()
        if (hoursArray.includes(getHours) !== true) {
            hoursArray.push(getHours)
            dataChartNewArrForOneday.push(dataChartPoints)
        }
    });

    return dataChartNewArrForOneday
}

const requestApiIntraday = (dataInput, originCountry, callbackOK, callbackKO) => {
    const dateFormat = DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_TIMESERIES
    const fromDate = moment(Date.now()).format(dateFormat)

    APIGet({
        undefined,
        endpoint: 'intradayDataMedysif',
        url: apiURLBuilder.getURL('intradayDataMedysif',
            {
                exchangeId: dataInput.exchangeId,
                spcSymbol: dataInput.spcSymbol,
                fromDate: encodeURIComponent(fromDate),
                originCountry: dataInput.originCountry
            }
        ),
    }).then(response => {
        callbackOK(prepareIntradayResponse(response.reverse()))
    })
    .catch((error) => {
        notifyError(error)
        callbackKO([])
    });

}

const requestApi = (dataInput, filterSelected, originCountry, callbackOK, callbackKO) => {
    const dates = getDates(filterSelected, originCountry)
    const fromDate = dates.fromDate
    const toDate = dates.toDate

    APIGet({
        undefined,
        endpoint: 'historicalDataMedysif',
        url: apiURLBuilder.getURL('historicalDataMedysif',
            {
                exchangeId: dataInput.exchangeId,
                spcSymbol: dataInput.spcSymbol,
                fromDate: encodeURIComponent(fromDate),
                toDate: encodeURIComponent(toDate),
                originCountry: dataInput.originCountry
            }
        ),
    }).then(response => {
        callbackOK(response.reverse())
    })
    .catch((error) => {
        notifyError(error)
        callbackKO([])
    });
}

module.exports = {
    requestApi,
    requestApiIntraday
}